import React from "react";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
const useStyles = makeThemedStyles("InputMeta", (theme) => ({
  root: {},
  heading: {
    textAlign: "start",
    fontFamily: "Arial",
    fontSize: "1.82em",
    fontWeight: 400,
    lineHeight: "1.25em",
    letterSpacing: "0em",
    color: "#374151",
    paddingLeft: "1.5em",
    paddingRight: "1.51em",
    marginTop: "15px",
    marginBottom: "15px",
  },
  content: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "10px 0px 10px 0px",
    /*
    background: "#EFF0F0",
    border: "0.11em solid #D1D5DB",
    boxShadow: "0em 0.11em 0.22em rgba(0, 0, 0, 0.05)",
    */
    borderRadius: "0.68em",
    margin: "0em 2.85em 0 2.74em",
  },
}));
/*
height: 2em; width: 2em; margin-right: 1.065em; margin-left: 0.66em; background: rgb(0, 169, 163); -webkit-mask: url("http://localhost:4000/http://localhost:4000/api/files/?file=/icons/navitems/corporate.svg") center center / contain no-repeat;
*/
const InputMeta = (
  props: React.PropsWithChildren<{
    title?: string | JSX.Element;
  }>
) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.heading}>{props.children}</div>
    </div>
  );
};

export default InputMeta;
